import { jsx, jsxs } from "react/jsx-runtime";
import { useCallback, useEffect, useState } from "react";
import debounce from "lodash/debounce";
import { Box } from "../../../../../Box/index.js";
import { Typography } from "../../../../../Typography/index.js";
import { Skeleton } from "../../../../../Skeleton/index.js";
import { InfiniteScroll } from "../../../../../InfiniteScroll/index.js";
import { useAdditionalFetchDataHelpersPluginCallback } from "../../AdditionalFetchDataHelpersPlugin/index.js";
import { UserItem } from "./UserItem.js";
const LIMIT = 20;
const UsersList = ({ inputValue, handleSelectValue })=>{
    const contextHelpers = useAdditionalFetchDataHelpersPluginCallback();
    const [data, setData] = useState([]);
    const [total, setTotal] = useState(0);
    const [offset, setOffset] = useState(0);
    const [isLoading, setIsLoading] = useState(true);
    const loadUsers = useCallback(()=>debounce((newOffset, savePrev)=>{
            setOffset(()=>newOffset);
            if (null == contextHelpers ? void 0 : contextHelpers.searchMentions) {
                setIsLoading(true);
                contextHelpers.searchMentions({
                    query: inputValue,
                    offset: newOffset,
                    limit: LIMIT
                }).then((res)=>{
                    setTotal(()=>res.total);
                    setData((prev)=>savePrev ? [
                            ...prev,
                            ...res.mentions
                        ] : res.mentions);
                    setIsLoading(()=>false);
                });
            }
        }, 300), [
        contextHelpers,
        inputValue
    ])();
    const loadNextUsers = useCallback(()=>{
        if (!isLoading) loadUsers(offset + LIMIT, true);
    }, [
        isLoading,
        loadUsers,
        offset
    ]);
    useEffect(()=>{
        loadUsers(0, false);
        return ()=>{
            loadUsers.cancel();
        };
    }, [
        inputValue
    ]);
    if (isLoading && !data.length) return /*#__PURE__*/ jsx(Box, {
        paddingY: "8",
        width: 290,
        children: /*#__PURE__*/ jsxs(Box, {
            px: "16",
            py: "12",
            display: "flex",
            alignItems: "center",
            gap: "8",
            children: [
                /*#__PURE__*/ jsx(Skeleton, {
                    variant: "circle",
                    height: 24,
                    width: 24
                }),
                /*#__PURE__*/ jsx(Skeleton, {
                    variant: "rect",
                    width: "calc(100% - 30px)",
                    height: 24
                })
            ]
        })
    });
    if (!data.length) return /*#__PURE__*/ jsx(Box, {
        paddingY: "8",
        width: 290,
        children: /*#__PURE__*/ jsx(Box, {
            px: "16",
            py: "12",
            display: "flex",
            alignItems: "center",
            gap: "8",
            children: /*#__PURE__*/ jsx(Typography, {
                variant: "body3",
                color: "text.light.tertirary",
                children: "Ничего не найдено"
            })
        })
    });
    return /*#__PURE__*/ jsx(Box, {
        paddingY: "8",
        width: 290,
        maxHeight: 256,
        overflow: "auto",
        id: "mention-users-list",
        children: /*#__PURE__*/ jsx(InfiniteScroll, {
            dataLength: data.length,
            next: loadNextUsers,
            hasMore: data.length < total && total > LIMIT,
            loader: isLoading ? /*#__PURE__*/ jsxs(Box, {
                px: "16",
                py: "12",
                display: "flex",
                alignItems: "center",
                gap: "8",
                children: [
                    /*#__PURE__*/ jsx(Skeleton, {
                        variant: "circle",
                        height: 24,
                        width: 24
                    }),
                    /*#__PURE__*/ jsx(Skeleton, {
                        variant: "rect",
                        width: "100%",
                        height: 24
                    })
                ]
            }) : null,
            endMessage: /*#__PURE__*/ jsx("div", {}),
            scrollId: "mention-users-list",
            children: /*#__PURE__*/ jsx(Box, {
                children: data.map((item, index)=>/*#__PURE__*/ jsx(UserItem, {
                        data: item.data,
                        inputValue: inputValue,
                        handleSelectValue: handleSelectValue
                    }, item.id + index))
            })
        })
    });
};
export { UsersList };
